// extracted by mini-css-extract-plugin
module.exports = {"default":"_93444fe79c--default--NLJo4","light":"_93444fe79c--light--32T7I","outline":"_93444fe79c--outline--2izsy"};